export default __webpack_public_path__ + "static/faster-87614e441e475db96eeb70475d283edd.png";